import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { ERROR_MESSAGE_REQUIRED } from '../../config'
import { useWallet } from '../../contexts/walletContext'
import {
  getAuthUser,
  logoutAuthUser,
  magicEmailLogin,
  walletAuth
} from '../../services/auth'
import { normaliseStr } from '../../utils'
import FormSlide from '../FormSlide'
import WalletConnectModal from '../WalletConnectModal'

export default function SignInUpSlide ({ nextTo, ...props }) {
  const { wallet } = useWallet()
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(false)

  useEffect(() => {
    console.log('Connected wallet:', wallet)
    const { provider } = wallet
    if (!provider) return

    // TODO: handle wallet auth errors (e.g. sig fail)
    walletAuth(wallet.wallet, provider.provider, () => {
      // Navigate to next page once auth successfully done
      navigate(nextTo)
    })
  }, [wallet])

  return (
    <FormSlide
      title='Lets Get Started'
      footerText={
        '<span class="fw-light">By proceeding, you agree to our <a href="/terms" target="_blank">T&Cs</a></span>'
      }
      showLogo={true}
      showNextButton={false}
      showProgress={false}
      showWallet={false}
      stageName='Let’s get started'
      description='Welcome to Aragon. We are a community of creatives, financial professionals, and entrepreneurial teams that are building the future of decentralized governance for Web3 communities & organizations.<br><br><i class="fw-light"><i class="bi bi-clock"></i>  10mins completion time</i>'
      rightContentClasses='d-grid gap-4 col-lg-10 col-12 pt-1 pb-1'
      rightContentHeader={
        <>
          <Button onClick={() => setModalShow(true)} size='lg'>
            Connect Wallet
          </Button>
          <div className='separator'>or</div>
          <WalletConnectModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
        </>
      }
      formData={[
        {
          label: 'email',
          placeholder: 'Email',
          type: 'email-input-submit-button',
          buttonText: 'Continue',
          size: 'lg',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        }
      ]}
      saveUser={false}
      onFormSubmit={async vals => {
        let { email } = vals
        if (email) email = normaliseStr(email)

        const authUser = getAuthUser()
        if (authUser && email !== authUser?.email) {
          // New signup, logout and reset
          await logoutAuthUser()
        }

        // Auth/Login
        console.log('Authenticating user', email)
        await magicEmailLogin(email, err => {
          // Just reload page when user wants to edit email
          window.location.reload()
        })
        // Go next on success
        navigate(nextTo)
      }}
      {...props}
    />
  )
}
